/* unplugin-vue-components disabled */import { render } from "./ScreenManage.vue?vue&type=template&id=5a363384&scoped=true"
import script from "./ScreenManage.vue?vue&type=script&lang=js"
export * from "./ScreenManage.vue?vue&type=script&lang=js"

import "./ScreenManage.vue?vue&type=style&index=0&id=5a363384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a363384"]])

export default __exports__